import { IconDefinition } from '@ant-design/icons-angular';

export const ThunderboltFill: IconDefinition = {
    name: 'thunderbolt',
    theme: 'fill',
    icon: '<svg viewBox="64 64 896 896" focusable="false"><path d="M848 359.3H627.7L825.8 109c4.1-5.3.4-13-6.3-13H436c-2.8 0-5.5 1.5-6.9 4L170 547.5c-3.1 5.3.7 12 6.9 12h174.4l-89.4 357.6c-1.9 7.8 7.5 13.3 13.3 7.7L853.5 373c5.2-4.9 1.7-13.7-5.5-13.7z" /></svg>'
}